import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import ServiceID from '@/App/Service/Entity/ServiceID'
import ServicePriceID from '@/App/Service/Entity/ServicePriceID'
import Money from '@/Shared/Entity/Money'
import type { ServicePriceData } from '@/Shared/AutoGenerated/Main'

export default class ServicePrice {
    constructor(
        public readonly id: ServicePriceID,
        public readonly serviceId: ServiceID,
        public readonly price: Money,
    ) {
        ensureNoUndefinedProperties(this)
    }

    calculateTotalPrice(
        numberOfRecurringMeetingsToSchedule: number,
        numberOfRequestedSeats: number,
    ): Money {
        return this.price
            .multiply(numberOfRecurringMeetingsToSchedule)
            .multiply(numberOfRequestedSeats)
    }

    // ------------------------
    // Hydration
    // ------------------------

    static hydrateSingle(entityData: ServicePriceData): ServicePrice {
        return new ServicePrice(
            new ServicePriceID(entityData.id),
            new ServiceID(entityData.serviceId),
            new Money(entityData.price.value, entityData.price.currency),
        )
    }

    static hydrateMultiple(entitiesData: any[]): ServicePrice[] {
        return entitiesData.map((entityData) => this.hydrateSingle(entityData))
    }
}
